<template>
  <div class="row site-page">
    <div class="col-md-12">
      <div class="section-header page-title">
        <h1>Ma consommation</h1>
        <p class="text-muted font-weight-light">
          Consommation sur les sept derniers jours
        </p>
      </div>
    </div>
    <InfosCard
      :cost="get_bill_field('calls', 'cost')"
      :duration="duration_call"
      :label="'Appels'"
      :icon="'kgk-mtn-BW_Icons_MyMTN_Voice_4'"
      :errorState="cardsErrors"
      @reload="loadRequest()"
    />
    <InfosCard
      :cost="get_bill_field('sms', 'cost')"
      :duration="duration_sms"
      :label="'SMS'"
      :icon="'kgk-mtn-BW_Icons_MyMTN_SMS_4'"
      :errorState="cardsErrors"
      @reload="loadRequest"
    />

    <InfosCard
      :cost="get_bill_field('others', 'cost')"
      :duration="duration_others"
      :label="'Autres'"
      :icon="'kgk-mtn-BW_Icons_MTNPlay_Social_4'"
      :errorState="cardsErrors"
      @reload="loadRequest"
    />

    <InfosCard
      :cost="''"
      :duration="duration_internet"
      :label="'Internet'"
      :icon="'kgk-mtn-BW_Icons_MyMTN_Data_4'"
      :errorState="internet_error"
      @reload="loadRequestInternet"
    />

    <div class="col-md-12">
      <SeeMoreBtn :btn_class="'float-right'" :path="'/consommation/'" />
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services";
import InfosCard from "@/components/utils/InfosCard";
import SeeMoreBtn from "@/components/utils/SeeMoreBtn";

export default {
  components: { InfosCard, SeeMoreBtn },
  name: "ConsumptionBox",
  data: function () {
    return {
      cardsErrors: false,
      duration_call: null,
      duration_sms: null,
      duration_others: null,
      duration_internet: null,
      internet_error: false,
      default_filter: {
        start: this.moment().subtract(7, "days").format("YYYYMMDD"),
        end: this.moment().format("YYYYMMDD"),
        label: "week",
      },
    };
  },
  created: async function () {
    if (this.$store.state.core.bill_details !== null) {
      if (this.$store.state.core.bill_details.total) {
        this.duration_call = this.get_bill_field("calls", "duration");
        this.duration_sms = this.get_bill_field("sms", "duration");
        this.duration_others = this.get_bill_field("others", "duration");
      } else {
        this.loadRequest();
      }
    } else {
      this.loadRequest();
    }
    if (this.$store.state.core.bill_internet !== null) {
      if (this.$store.state.core.bill_internet.mbtotal) {
        this.duration_internet = this.get_internet_total();
      } else {
        this.loadRequestInternet();
      }
    } else {
      this.loadRequestInternet();
    }
  },
  methods: {
    get_bill_field: function (field, sub_field) {
      try {
        const data =
          this.$store.state.core.bill_details.total[field][sub_field];
        if (field.trim() == "calls" && sub_field.trim() === "duration") {
          return this.formatCallDatas(data);
        } else {
          return data;
        }
      } catch (error) {
        return null;
      }
    },
    get_internet_total() {
      try {
        return this.formatInternetData(
          this.$store.state.core.bill_internet.mbtotal
        );
      } catch (error) {
        return null;
      }
    },
    async loadRequest() {
      this.duration_call = null;
      this.duration_sms = null;
      this.duration_others = null;
      this.cardsErrors = false;
      try {
        await subscriber
          .get_bill_details(this.default_filter)
          .then((response) => {
            if (response.error || response.internal_error) {
              this.cardsErrors = true;
            }
            this.duration_call = this.get_bill_field("calls", "duration");
            this.duration_sms = this.get_bill_field("sms", "duration");
            this.duration_others = this.get_bill_field("others", "duration");
          });
      } catch (error) {}
    },
    async loadRequestInternet() {
      this.duration_internet = null;
      this.internet_error = false;
      try {
        await subscriber
          .get_bill_internet_details(this.default_filter)
          .then((response) => {
            if (response.error || response.internal_error) {
              this.internet_error = true;
            }
            this.duration_internet = this.get_internet_total();
          });
      } catch (error) {}
    },
  },
};
</script>
<style scoped lang="css">
</style>
